import { createContext, useContext } from "react";

export const LangContext = createContext({ lang: "it", setLang: () => {} });
export const useLang = () => useContext(LangContext);

export const copy = {
  it: {
    nav: {
      torque: "Torque",
      archive: "Archivio",
      access: "Accesso",
    },
    hero: {
      kicker: "Atelier di opere dinamiche 1/1",
      line1: "TORQUE 1/1",
      lines2: ["Persona. Visione. Creazione."],
      intro1: "Il rumore",
      intro2: "non è lusso™.",
      cue: "Scendere, lentamente",
    },
    chapters: [
      {
        title: null,
        paras: [
          "FMF è un atelier indipendente dedicato alla creazione di opere dinamiche uniche.",
          "Ogni TORQUE è concepito per un solo individuo, attraverso un processo privato di dialogo, interpretazione e creazione.",
          "Non ci sono modelli tra cui scegliere. Nessun catalogo. Nessuna configurazione da combinare.",
          "C'è un solo inizio: tu.",
        ],
      },
      {
        title: "Non su misura — Co-creato",
        paras: [
          "Un TORQUE non è una motocicletta da configurare.",
          "Inizia prima che materiali, colori, superfici o dettagli tecnici vengano presi in considerazione. Inizia con una conversazione.",
          "Esploriamo la persona dietro la commissione: la sua sensibilità, i suoi riferimenti, il suo rapporto con gli oggetti, il movimento, il design e la bellezza.",
          "Da questo dialogo, FMF inizia a interpretare.",
          "Le idee diventano gesti. I gesti diventano disegni. I disegni diventano forma.",
          "Il cliente non disegna l'oggetto. Il cliente lo ispira.",
          "FMF traduce quell'ispirazione in qualcosa che non esisteva prima.",
        ],
      },
      {
        title: "Un dialogo prima dell'oggetto",
        paras: [
          "Ogni TORQUE inizia in privato.",
          "La prima conversazione è deliberatamente priva di specifiche, configurazioni e soluzioni predefinite.",
          "Non ci interessa scoprire cosa vorresti aggiungere a una motocicletta.",
          "Vogliamo capire cosa dovrebbe esistere grazie a te.",
          "I tuoi riferimenti estetici. Il tuo rapporto con l'artigianato. Gli oggetti che hai conservato. Gli oggetti che hai rifiutato. I dettagli che contano solo per te.",
          "Alcuni di questi elementi potranno diventare visibili. Altri potranno influenzare una proporzione, una superficie, un dettaglio meccanico, un colore o semplicemente il carattere della creazione.",
          "Il risultato non è la somma di una lista di scelte. È un'interpretazione.",
        ],
      },
      {
        title: "Interpretazione",
        paras: [
          "Tu porti la storia. Noi le diamo forma.",
          "Quando il dialogo è iniziato, FMF traduce ciò che è emerso in una direzione creativa.",
          "Appaiono gli schizzi. Le proporzioni cambiano. I dettagli vengono disegnati, messi in discussione e ridisegnati.",
          "Le soluzioni vengono esplorate e a volte abbandonate. Il processo è deliberatamente umano.",
          "Nessun configuratore è in grado di produrre un TORQUE, perché le informazioni più importanti non esistono dentro un configuratore.",
          "Esistono dentro la persona.",
        ],
      },
      {
        title: "Co-creazione",
        paras: [
          "La creazione evolve attraverso uno scambio continuo tra il suo futuro proprietario e FMF.",
          "Non ogni decisione viene presentata come un'opzione. Non ogni possibilità diventa una scelta.",
          "FMF conserva la firma e la direzione creativa, mentre l'individuo rimane l'origine dell'opera.",
          "Questa tensione è fondamentale.",
          "Senza l'individuo, quel TORQUE non potrebbe mai esistere. Senza FMF, non potrebbe mai prendere quella forma.",
          "Per questo ogni TORQUE completato porta con sé due storie: la storia del suo autore e la storia del suo co-autore.",
        ],
      },
      {
        title: "One of One",
        paras: [
          "Non una di una serie.",
          "1/1 non è un numero di produzione. È una promessa.",
          "Quando un TORQUE è completato, la sua combinazione di forma, dettagli, finiture e decisioni creative viene chiusa per sempre.",
          "Non diventerà un modello. Non diventerà un'edizione.",
          "Un altro cliente non potrà richiedere la stessa creazione. E FMF non la riprodurrà.",
          "Ciò che è stato creato una volta, resta una volta.",
        ],
      },
      {
        title: "Il non mostrato",
        paras: [
          "La maggior parte di un TORQUE non apparirà mai qui.",
          "Non pubblichiamo creazioni complete. Non costruiamo gallerie di commissioni passate. Non offriamo ai futuri clienti un catalogo di ciò che è già stato fatto.",
          "Perché vedere il TORQUE di un'altra persona non deve mai diventare il punto di partenza del tuo.",
          "Solo frammenti potranno essere occasionalmente rivelati: una linea, uno schizzo, un gesto, un dettaglio meccanico, un'ombra.",
          "Abbastanza per comprendere il linguaggio. Mai abbastanza per riprodurre l'opera.",
        ],
      },
      {
        title: "Il tempo",
        paras: [
          "Un TORQUE non viene assemblato da una sequenza di opzioni disponibili. Prende forma nel tempo.",
          "Tempo per capire. Tempo per disegnare. Tempo per riconsiderare. Tempo per fare. Tempo per togliere ciò che non è necessario.",
          "La tecnologia rende molte cose più veloci. La creazione non ha bisogno di esserlo.",
        ],
      },
      {
        title: "La rivelazione",
        paras: [
          "C'è un momento in cui il dialogo finisce. L'oggetto è completo.",
          "Non più un progetto. Non più un disegno. Non più un'interpretazione. Un TORQUE.",
          "La sua prima apparizione completa è riservata alla persona per cui è stato creato.",
          "Non una consegna. Una rivelazione.",
        ],
      },
      {
        title: "TORQUE 1/1",
        paras: [
          "Ci saranno altre creazioni TORQUE. Non ci sarà mai un'altra tua.",
          "Creata una volta. Per una persona. Mai più.",
        ],
      },
    ],
    marquee:
      "ATELIER DI OPERE DINAMICHE 1/1 — OPERA UNICA — SILENZIO — ASSENZA — TORQUE 1/1 — ",
    archive: {
      kicker: "L'Archivio",
      paras: [
        "Ogni TORQUE lascia una traccia.",
        "Gli schizzi originali. Il periodo della creazione. Le decisioni creative. Le idee abbandonate. I dettagli sopravvissuti.",
        "Le firme dell'autore e del co-autore.",
        "Insieme diventano il registro privato dell'opera.",
        "Quando la creazione è completata, la sua storia viene chiusa e conservata nell'Archivio FMF.",
        "Non come un catalogo. Come memoria.",
      ],
      entries: ["TORQUE / 01 / ———", "TORQUE / 02 / ———", "TORQUE / 03 / ———"],
      final: "Questa creazione non esisterà mai più.",
    },
    access: {
      statement: "Non tutti dovrebbero possederne una.",
      title: "Accesso Privato",
      note: "FMF non accetta commissioni attraverso questo sito. Le presentazioni possono essere prese in considerazione.",
      codeLabel: "Codice privato",
      submit: "Entrare",
      verifying: "Verifica…",
      denied: "Il codice non è riconosciuto.",
      locked: "Troppi tentativi. Attendere.",
      introLabel: "Presentazione privata",
      introPlaceholder: "Un nome. Un riferimento. Nulla di più.",
      introSubmit: "Lasciare",
      introDone: "Sarà letta. In silenzio.",
    },
    footer: {
      line: "FMF — Atelier di opere dinamiche 1/1",
      note: "Su invito, soltanto.",
      join: "Join the experience",
      email: "creation@fmf-oneof.com",
    },
    contact: {
      title: "Iniziare un dialogo",
      nome: "Nome",
      cognome: "Cognome",
      email: "Email",
      telefono: "Telefono",
      stato: "Stato",
      citta: "Città",
      message: "Parlaci di te e perché vorresti TORQUE.",
      submit: "Inviare",
      sending: "Invio…",
      done: "Ricevuto. In silenzio.",
    },
    banner: {
      text: "Questo sito usa solo memorizzazioni tecniche essenziali. Nessuna profilazione, nessun tracciamento.",
      accept: "Accetto",
      decline: "Rifiuto",
      more: "Privacy e Cookie Policy",
    },
    legal: {
      privacy: {
        title: "Privacy Policy",
        paras: [
          "Titolare del trattamento: FMF — Atelier di opere dinamiche 1/1, VAT 11919330966. Contatto: creation@fmf-oneof.com.",
          "Dati raccolti: attraverso il modulo di contatto raccogliamo nome, cognome, indirizzo email, telefono, Stato, città e il messaggio che scegli di condividere.",
          "Finalità: i dati vengono utilizzati esclusivamente per valutare e gestire l'avvio di un dialogo privato relativo a una possibile creazione TORQUE.",
          "Base giuridica: l'invio volontario dei dati attraverso il modulo costituisce consenso al trattamento per le finalità indicate.",
          "Conservazione: i dati sono conservati per il tempo necessario a gestire il dialogo e comunque non oltre 24 mesi dall'ultimo contatto.",
          "I dati non vengono venduti, ceduti o comunicati a terzi, salvo obblighi di legge.",
          "Diritti: puoi richiedere in qualsiasi momento accesso, rettifica o cancellazione dei tuoi dati scrivendo a creation@fmf-oneof.com.",
          "Questo sito non effettua profilazione né remarketing.",
        ],
      },
      cookie: {
        title: "Cookie Policy",
        paras: [
          "Questo sito non utilizza cookie di profilazione, analitici o di terze parti.",
          "Vengono utilizzate esclusivamente memorizzazioni tecniche locali per ricordare la lingua scelta e la tua risposta all'avviso.",
          "Nessuna informazione di navigazione viene raccolta, tracciata o condivisa.",
          "Puoi cancellare le memorizzazioni locali in qualsiasi momento dalle impostazioni del tuo browser.",
        ],
      },
    },
    private: {
      granted: "Accesso riconosciuto.",
      preparing:
        "Questo spazio è in preparazione. Ogni invito è personale e sarà annunciato privatamente.",
      invalid: "Questo spazio non è aperto.",
      back: "Tornare al silenzio",
      checking: "…",
    },
  },
  en: {
    nav: {
      torque: "Torque",
      archive: "Archive",
      access: "Access",
    },
    hero: {
      kicker: "Atelier of dynamic works 1/1",
      line1: "TORQUE 1/1",
      lines2: ["Person. Vision. Creation."],
      intro1: "Noise",
      intro2: "is not luxury™.",
      cue: "Descend, slowly",
    },
    chapters: [
      {
        title: null,
        paras: [
          "FMF is an independent atelier devoted to the creation of unique dynamic works.",
          "Every TORQUE is conceived for one individual, through a private process of dialogue, interpretation and creation.",
          "There are no models to choose from. No catalogue. No configurations to combine.",
          "There is only one beginning: you.",
        ],
      },
      {
        title: "Not custom made — Co-created",
        paras: [
          "A TORQUE is not a motorcycle to configure.",
          "It begins before materials, colours, surfaces or technical details are considered. It begins with a conversation.",
          "We explore the person behind the commission: their sensibility, their references, their relationship with objects, movement, design and beauty.",
          "From this dialogue, FMF begins to interpret.",
          "Ideas become gestures. Gestures become drawings. Drawings become form.",
          "The client does not design the object. The client inspires it.",
          "FMF translates that inspiration into something that did not exist before.",
        ],
      },
      {
        title: "A dialogue before an object",
        paras: [
          "Every TORQUE begins privately.",
          "The first conversation is deliberately free from specifications, configurations and predefined solutions.",
          "We are not interested in discovering what you would like to add to a motorcycle.",
          "We want to understand what should exist because of you.",
          "Your aesthetic references. Your relationship with craftsmanship. Objects you have kept. Objects you have rejected. Details that matter only to you.",
          "Some of these elements may eventually become visible. Others may influence a proportion, a surface, a mechanical detail, a colour or simply the character of the creation.",
          "The result is not the sum of a list of choices. It is an interpretation.",
        ],
      },
      {
        title: "Interpretation",
        paras: [
          "You bring the story. We give it form.",
          "Once the dialogue has begun, FMF translates what has emerged into a creative direction.",
          "Sketches appear. Proportions change. Details are drawn, questioned and redrawn.",
          "Solutions are explored and sometimes abandoned. The process is deliberately human.",
          "There is no configurator capable of producing a TORQUE because the most important information does not exist inside a configurator.",
          "It exists inside the person.",
        ],
      },
      {
        title: "Co-creation",
        paras: [
          "The creation evolves through a continuous exchange between its future owner and FMF.",
          "Not every decision is presented as an option. Not every possibility becomes a choice.",
          "FMF retains authorship and creative direction, while the individual remains the origin of the work.",
          "This tension is fundamental.",
          "Without the individual, that TORQUE could never exist. Without FMF, it could never take that form.",
          "For this reason, every completed TORQUE carries two histories: the history of its author and the history of its co-author.",
        ],
      },
      {
        title: "One of One",
        paras: [
          "Not one of a series.",
          "1/1 is not a production number. It is a promise.",
          "When a TORQUE is completed, its combination of form, details, finishes and creative decisions is closed permanently.",
          "It will not become a model. It will not become an edition.",
          "Another client cannot request the same creation. And FMF will not reproduce it.",
          "What has been created once remains once.",
        ],
      },
      {
        title: "The unseen",
        paras: [
          "Most of a TORQUE will never appear here.",
          "We do not publish complete creations. We do not build galleries of previous commissions. We do not provide future clients with a catalogue of what has already been done.",
          "Because seeing another person's TORQUE should never become the starting point for yours.",
          "Only fragments may occasionally be revealed: a line, a sketch, a gesture, a mechanical detail, a shadow.",
          "Enough to understand the language. Never enough to reproduce the work.",
        ],
      },
      {
        title: "Time",
        paras: [
          "A TORQUE is not assembled from a sequence of available options. It takes shape over time.",
          "Time to understand. Time to draw. Time to reconsider. Time to make. Time to remove what is unnecessary.",
          "Technology makes many things faster. Creation does not need to be one of them.",
        ],
      },
      {
        title: "The reveal",
        paras: [
          "There is a moment when the dialogue ends. The object is complete.",
          "No longer a project. No longer a drawing. No longer an interpretation. A TORQUE.",
          "Its first complete appearance is reserved for the person for whom it was created.",
          "Not a delivery. A revelation.",
        ],
      },
      {
        title: "TORQUE 1/1",
        paras: [
          "There will be other TORQUE creations. There will never be another yours.",
          "Created once. For one. Never again.",
        ],
      },
    ],
    marquee:
      "ATELIER OF DYNAMIC WORKS 1/1 — ONE OF ONE — SILENCE — ABSENCE — TORQUE 1/1 — ",
    archive: {
      kicker: "The Archive",
      paras: [
        "Every TORQUE leaves a trace.",
        "Original sketches. The period of creation. Creative decisions. Ideas that were abandoned. Details that survived.",
        "The signatures of author and co-author.",
        "Together they become the private record of the work.",
        "When the creation is completed, its story is closed and preserved within the FMF Archive.",
        "Not as a catalogue. As memory.",
      ],
      entries: ["TORQUE / 01 / ———", "TORQUE / 02 / ———", "TORQUE / 03 / ———"],
      final: "This creation will never exist again.",
    },
    access: {
      statement: "Not everyone should own one.",
      title: "Private Access",
      note: "FMF does not accept commissions through this website. Introductions may be considered.",
      codeLabel: "Private code",
      submit: "Enter",
      verifying: "Verifying…",
      denied: "The code is not recognized.",
      locked: "Too many attempts. Please wait.",
      introLabel: "Private introduction",
      introPlaceholder: "A name. A reference. Nothing more.",
      introSubmit: "Leave",
      introDone: "It will be read. In silence.",
    },
    footer: {
      line: "FMF — Atelier of dynamic works 1/1",
      note: "Invitation only.",
      join: "Join the experience",
      email: "creation@fmf-oneof.com",
    },
    contact: {
      title: "Begin a dialogue",
      nome: "Name",
      cognome: "Surname",
      email: "Email",
      telefono: "Phone",
      stato: "Country",
      citta: "City",
      message: "Tell us about you and why you would like a TORQUE.",
      submit: "Send",
      sending: "Sending…",
      done: "Received. In silence.",
    },
    banner: {
      text: "This site uses only essential technical storage. No profiling, no tracking.",
      accept: "Accept",
      decline: "Decline",
      more: "Privacy & Cookie Policy",
    },
    legal: {
      privacy: {
        title: "Privacy Policy",
        paras: [
          "Data controller: FMF — Atelier of dynamic works 1/1, VAT 11919330966. Contact: creation@fmf-oneof.com.",
          "Data collected: through the contact form we collect name, surname, email address, phone number, country, city and the message you choose to share.",
          "Purpose: the data is used exclusively to evaluate and manage the beginning of a private dialogue about a possible TORQUE creation.",
          "Legal basis: the voluntary submission of data through the form constitutes consent to processing for the stated purposes.",
          "Retention: data is kept for the time needed to manage the dialogue and in any case no longer than 24 months from the last contact.",
          "Data is never sold, transferred or shared with third parties, except where required by law.",
          "Your rights: you may request access, rectification or deletion of your data at any time by writing to creation@fmf-oneof.com.",
          "This site performs no profiling and no remarketing.",
        ],
      },
      cookie: {
        title: "Cookie Policy",
        paras: [
          "This site does not use profiling, analytics or third-party cookies.",
          "Only essential technical storage is used, to remember your chosen language and your answer to this notice.",
          "No browsing information is collected, tracked or shared.",
          "You can clear local storage at any time from your browser settings.",
        ],
      },
    },
    private: {
      granted: "Access recognized.",
      preparing:
        "This space is in preparation. Every invitation is personal and will be announced privately.",
      invalid: "This space is not open.",
      back: "Return to silence",
      checking: "…",
    },
  },
};

